// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__IqCYc","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2-R3E"};